import React from "react";
import { IconSize, IconProps } from "../theme";

const Ticket: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame">
        <path
          id="Vector"
          d="M27 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V26C3.00009 26.1704 3.04374 26.338 3.12681 26.4869C3.20988 26.6357 3.32961 26.7608 3.47463 26.8503C3.61965 26.9399 3.78516 26.9909 3.95543 26.9985C4.12569 27.0061 4.29508 26.97 4.4475 26.8937L8 25.1175L11.5525 26.8937C11.6914 26.9633 11.8446 26.9995 12 26.9995C12.1554 26.9995 12.3086 26.9633 12.4475 26.8937L16 25.1175L19.5525 26.8937C19.6914 26.9633 19.8446 26.9995 20 26.9995C20.1554 26.9995 20.3086 26.9633 20.4475 26.8937L24 25.1175L27.5525 26.8937C27.7049 26.97 27.8743 27.0061 28.0446 26.9985C28.2148 26.9909 28.3803 26.9399 28.5254 26.8503C28.6704 26.7608 28.7901 26.6357 28.8732 26.4869C28.9563 26.338 28.9999 26.1704 29 26V7C29 6.46957 28.7893 5.96086 28.4142 5.58579C28.0391 5.21071 27.5304 5 27 5ZM22 18H10C9.73478 18 9.48043 17.8946 9.29289 17.7071C9.10536 17.5196 9 17.2652 9 17C9 16.7348 9.10536 16.4804 9.29289 16.2929C9.48043 16.1054 9.73478 16 10 16H22C22.2652 16 22.5196 16.1054 22.7071 16.2929C22.8946 16.4804 23 16.7348 23 17C23 17.2652 22.8946 17.5196 22.7071 17.7071C22.5196 17.8946 22.2652 18 22 18ZM22 14H10C9.73478 14 9.48043 13.8946 9.29289 13.7071C9.10536 13.5196 9 13.2652 9 13C9 12.7348 9.10536 12.4804 9.29289 12.2929C9.48043 12.1054 9.73478 12 10 12H22C22.2652 12 22.5196 12.1054 22.7071 12.2929C22.8946 12.4804 23 12.7348 23 13C23 13.2652 22.8946 13.5196 22.7071 13.7071C22.5196 13.8946 22.2652 14 22 14Z"
          fill="#071443"
        />
      </g>
    </svg>
  );
};

export default Ticket;
